import React, { Component } from "react";
import { MDBInput, MDBBtn } from "mdb-react-ui-kit";
import ModalPortal from "./ModalPortal";
import { MfmImageUploader } from "Projects/CC_cubi_clan_project/GlobalComponents/MfmImageUploader/MfmImageUploader";
import RichTextEditor from "Projects/CC_cubi_clan_project/GlobalComponents/RichTextEditor/RichTextEditor";
import "./VenueItemModal.css";

const stripDataUrl = (dataUri) =>
  dataUri && String(dataUri).startsWith("data:image")
    ? String(dataUri).replace(/^data:image\/[a-zA-Z0-9+.+-]+;base64,/, "")
    : dataUri || "";

export default class VenueItemModal extends Component {
  constructor(props) {
    super(props);

    const incoming = props.item || {};
    const initial = {
      idRepresentacion: incoming.idRepresentacion ?? null,
      status: incoming.status || "draft",
      // nuevo modelo
      name: incoming.name || "",
      description: incoming.description || "",
      enlaceUrl: incoming.enlaceUrl || "",
      imageBase64: incoming.imageBase64 || "",
      imageUuid: incoming.imageUuid || null,
      address: incoming.address || "",
      fechas: (incoming.fechas || []).map((f) => ({
        idRepresentacionFecha: f.idRepresentacionFecha ?? null,
        startDatetime: f.startDatetime ? f.startDatetime.substring(0, 16) : "",
        endDatetime: f.endDatetime ? f.endDatetime.substring(0, 16) : "",
      })),
    };

    this.state = {
      item: JSON.parse(JSON.stringify(initial)),
      // control del mapa con debounce
      addressInput: initial.address || "",
      mapQuery: initial.address || "",
      debounceMs: 2000,
    };

    this._mapTimer = null;
  }

  componentDidMount() {
    document.body.classList.add("modal-open");
  }
  componentWillUnmount() {
    document.body.classList.remove("modal-open");
    if (this._mapTimer) clearTimeout(this._mapTimer);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.item !== this.props.item) {
      const incoming = this.props.item || {};
      const next = {
        idRepresentacion: incoming.idRepresentacion ?? null,
        status: incoming.status || "draft",
        name: incoming.name || "",
        description: incoming.description || "",
        enlaceUrl: incoming.enlaceUrl || "",
        imageBase64: incoming.imageBase64 || "",
        imageUuid: incoming.imageUuid || null,
        address: incoming.address || "",
        fechas: (incoming.fechas || []).map((f) => ({
          idRepresentacionFecha: f.idRepresentacionFecha ?? null,
          startDatetime: f.startDatetime ? f.startDatetime.substring(0, 16) : "",
          endDatetime: f.endDatetime ? f.endDatetime.substring(0, 16) : "",
        })),
      };
      this.setState({
        item: JSON.parse(JSON.stringify(next)),
        addressInput: next.address || "",
        mapQuery: next.address || "",
      });
    }
  }

  onField = (k, v) => this.setState((s) => ({ item: { ...s.item, [k]: v } }));

  addFecha = () => {
    this.setState((s) => ({
      item: {
        ...s.item,
        fechas: [...s.item.fechas, { idRepresentacionFecha: null, startDatetime: "", endDatetime: "" }],
      },
    }));
  };

  removeFecha = (index) => {
    this.setState((s) => ({
      item: {
        ...s.item,
        fechas: s.item.fechas.filter((_, i) => i !== index),
      },
    }));
  };

  updateFecha = (index, field, value) => {
    this.setState((s) => {
      const fechas = s.item.fechas.map((f, i) => (i === index ? { ...f, [field]: value } : f));
      return { item: { ...s.item, fechas } };
    });
  };

  onAddressChange = (v) => {
    // actualiza input y modelo inmediatamente
    this.setState((s) => ({ addressInput: v, item: { ...s.item, address: v } }));
    // reinicia debounce
    if (this._mapTimer) clearTimeout(this._mapTimer);
    this._mapTimer = setTimeout(() => {
      this.setState({ mapQuery: v });
    }, this.state.debounceMs);
  };

  buildPayload = () => {
    const out = JSON.parse(JSON.stringify(this.state.item));
    // si hay UUID de MFM, nullear base64 para no enviar datos redundantes
    if (out.imageUuid) out.imageBase64 = null;
    return out;
  };

  renderMap() {
    const { mapQuery } = this.state;
    const q = encodeURIComponent(mapQuery || "");
    const src = mapQuery
      ? `https://www.google.com/maps?q=${q}&output=embed`
      : `https://www.google.com/maps?q=Madrid&output=embed`;

    return (
      <div className="vimv-map">
        <iframe
          key={src}
          title="Mapa de ubicación"
          src={src}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>
    );
  }

  render() {
    const { onClose, onSave, onDelete } = this.props;
    const { item, addressInput } = this.state;
    const isDraft = String(item.status || "draft").toLowerCase() === "draft";

    return (
      <ModalPortal>
        <div className="modal-overlay" onClick={onClose}>
          <div className="modal-card detail-modal-card" onClick={(e) => e.stopPropagation()}>
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center detail-modal-header">
              <h5 className="detail-modal-title mb-0">Editar lugar de representación</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Cerrar" />
            </div>

            <div className="detail-modal-body">
              {/* Imagen (editable) */}
              <div className="vimv-uploader">
                <MfmImageUploader
                  uuid={item.imageUuid || null}
                  appCode="TEAN"
                  library="representaciones"
                  size="medium"
                  mediaType="image"
                  mediaFormat="16/9"
                  mediaFrameSize="320x180"
                  onUpload={(result) => this.onField("imageUuid", result.uuid)}
                  onDelete={() => this.onField("imageUuid", null)}
                />
              </div>

              {/* Campos editables */}
              <div className="detail-modal-section">
                {/* Estado de publicación */}
                <div className="vimv-status-toggle mb-3">
                  <span className="vimv-status-label">Estado:</span>
                  <button
                    type="button"
                    className={`vimv-status-btn ${isDraft ? "active-draft" : ""}`}
                    onClick={() => this.onField("status", "draft")}
                  >
                    <i className="fas fa-pencil-alt me-1" />Borrador
                  </button>
                  <button
                    type="button"
                    className={`vimv-status-btn ${!isDraft ? "active-published" : ""}`}
                    onClick={() => this.onField("status", "published")}
                  >
                    <i className="fas fa-globe me-1" />Publicado
                  </button>
                </div>

                <MDBInput
                  label="Nombre del lugar"
                  className="mb-3"
                  value={item.name}
                  onChange={(e) => this.onField("name", e.target.value)}
                />

                <MDBInput
                  label="Dirección"
                  className="mb-3"
                  value={addressInput}
                  onChange={(e) => this.onAddressChange(e.target.value)}
                />

                <MDBInput
                  label="Enlace al lugar (URL)"
                  className="mb-3"
                  type="url"
                  placeholder="https://..."
                  value={item.enlaceUrl}
                  onChange={(e) => this.onField("enlaceUrl", e.target.value)}
                />

                <div className="mb-3">
                  <label className="form-label vimv-rte-label">Descripción</label>
                  <RichTextEditor
                    initialHtml={item.description}
                    onChangeHtml={(html) => this.onField("description", html)}
                    height={160}
                  />
                </div>
              </div>

              {/* Fechas de representación */}
              <div className="detail-modal-section">
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h6 className="detail-modal-subtitle mb-0">Fechas de representación</h6>
                  <MDBBtn size="sm" className="tean-btn-primary" onClick={this.addFecha}>
                    <i className="fas fa-plus me-1" />Añadir fecha
                  </MDBBtn>
                </div>
                {item.fechas.length === 0 && (
                  <p className="text-muted small mb-0">Sin fechas programadas.</p>
                )}
                {item.fechas.map((f, i) => (
                  <div key={i} className="vimv-fecha-row d-flex align-items-center gap-2 mb-2">
                    <div className="flex-grow-1">
                      <MDBInput
                        label="Inicio"
                        type="datetime-local"
                        value={f.startDatetime}
                        onChange={(e) => this.updateFecha(i, "startDatetime", e.target.value)}
                      />
                    </div>
                    <div className="flex-grow-1">
                      <MDBInput
                        label="Fin (opcional)"
                        type="datetime-local"
                        value={f.endDatetime}
                        onChange={(e) => this.updateFecha(i, "endDatetime", e.target.value)}
                      />
                    </div>
                    <button
                      type="button"
                      className="btn btn-link text-danger p-1"
                      title="Eliminar fecha"
                      onClick={() => this.removeFecha(i)}
                    >
                      <i className="fas fa-trash-alt" />
                    </button>
                  </div>
                ))}
              </div>

              {/* Mapa en tiempo real con debounce */}
              <div className="detail-modal-section">
                <h6 className="detail-modal-subtitle">Ubicación en el mapa</h6>
                {this.renderMap()}
              </div>
            </div>

            {/* Acciones */}
            <div className="vimv-actions d-flex align-items-center">
              {onDelete && (
                <MDBBtn color="danger" outline onClick={onDelete}>
                  Eliminar
                </MDBBtn>
              )}
              <div style={{ flex: 1 }} />
              <MDBBtn color="secondary" onClick={onClose}>
                Cancelar
              </MDBBtn>
              <MDBBtn
                className="tean-btn-primary"
                onClick={() => onSave?.(this.buildPayload())}
              >
                Guardar
              </MDBBtn>
            </div>
          </div>
        </div>
      </ModalPortal>
    );
  }
}
